import { useRef, useState, useEffect } from 'react';

export const AnimatedSection = ({ children }) => {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              observer.unobserve(entry.target); // Trigger only once
            }
          });
        },
        { threshold: 0.2 } // 20% of the section should be visible before animation
      );
  
      if (ref.current) observer.observe(ref.current);
  
      return () => {
        if (ref.current) observer.unobserve(ref.current);
      };
    }, []);
  
    return (
      <div
        ref={ref}
        className={`transition-all duration-1000 ease-out transform ${
          isVisible
            ? "opacity-100 translate-y-0 "
            : "opacity-0 translate-y-40 "
        }`}
      >
        {children}
      </div>
    );
  };